import { Grid,Typography,Box, ToggleButton, ToggleButtonGroup,TextField,  InputAdornment, FormControl, InputLabel, Select, MenuItem, IconButton, Tooltip, TablePagination } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useState, useEffect } from 'react';
import PriorityTransaction from './PriorityTransaction';
import ListViewPriorityTransaction from './ListViewPriorityTransaction';
import NotificationPermissionDialog from 'components/NotificationPermissionDialog';
import useFCM from 'hooks/useFCM';
import useApi from 'hooks/useApi';
// import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import useSelection from 'hooks/useSelection';
import useClientAutoSelector from 'hooks/useClientAutoSelector';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import TableRowsIcon from "@mui/icons-material/TableRows";
import ClientFilter from 'components/ClientFilter';

const NewDashboard = () => {
  const [viewMode, setViewMode] = useState<ViewMode>("table");
  const [showNotificationDialog, setShowNotificationDialog] = useState(false);
  const { hasPermission, isSupported, isLoading, requestPermission, setupMessageListener } = useFCM();
  const [isLoadingData, setLoading] = useState(false);
  const [transactionData, setTransactionData] = useState<any>({ rows: [] });
    const { setSelectedClient, selectedTeam, setSelectedTeam, selectedClient, clientOptions, refreshClients } = useSelection();
  const [teamOptions, setTeamOptions] = useState<any[]>([]);
  const [search, setSearch] = useState<string>('');
  const { getTeamByClient,user,getPriorityTransactions, showToast,getNodeStatus } = useApi();
  const [transactionCount, setTransactionCount] = useState({all:0,priority:0,alert:0});
  console.log("transactions",transactionData?.data)
  const [keyStatusMap,setKeyStatusMap]=useState<any>(null);
  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
      type StatusFilterType = 'all' | 'ALERT' | 'PRIORITY';
    
    const [filters, setFilters] = useState(() => {
    const saved = localStorage.getItem("priorityFilters");
    const defaultFilters = {
      selectedClient: "",
      selectedTeamTable: "all",
      selectedTeamCard: "",
      statusFilter: "all" as StatusFilterType
    };
    
    if (saved) {
      const parsed = JSON.parse(saved);
      // Validate the status filter value
      const validStatus = (value: string): value is StatusFilterType => 
        ['all', 'ALERT', 'PRIORITY'].includes(value);
      
      // Ensure we only use valid status filter values
      const statusFilter = validStatus(parsed.statusFilter) ? parsed.statusFilter : defaultFilters.statusFilter;
      
      return {
        ...defaultFilters,
        ...parsed,
        selectedTeamTable: parsed.selectedTeamTable || "all",
        statusFilter // Use validated status filter
      };
    }
    
    return defaultFilters;
  });

  const handleFilterChange = (key: keyof typeof filters, value: any) => {
  setFilters((prev:any) => {
    const updated = { ...prev, [key]: value };
    localStorage.setItem("priorityFilters", JSON.stringify(updated));
    return updated;
  });
};
  // Auto-select client if there's only one available (important for users with dashboard access)
  useClientAutoSelector();
  
  type ViewMode = "card" | "table";

const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    newView: ViewMode | null
  ) => {
    setLoading(false);
    setTransactionData([]);
    if (newView !== null) {
      setViewMode(newView);
      localStorage.setItem("priorityViewMode", newView);
    }
  };

  useEffect(() => {
    const savedView = localStorage.getItem("priorityViewMode") as ViewMode | null;
    if (savedView) {
      setViewMode(savedView);
    }
  }, []);

  // Check if we should show the notification permission dialog
  useEffect(() => {
    if (user && isSupported && !hasPermission) {
      // Check if user has previously dismissed the dialog
      const dismissed = localStorage.getItem('fcm-permission-dismissed');
      if (!dismissed) {
        // Show dialog after a short delay to let the dashboard load
        const timer = setTimeout(() => {
          setShowNotificationDialog(true);
        }, 2000);
        return () => clearTimeout(timer);
      }
    }
  }, [user, isSupported, hasPermission]);

  // Setup message listener when permission is granted
  useEffect(() => {
    if (hasPermission) {
      const unsubscribe = setupMessageListener();
      return unsubscribe;
    }
  }, [hasPermission, setupMessageListener]);

  const handleNotificationAccept = async () => {
    try {
      await requestPermission();
      setShowNotificationDialog(false);
    } catch (error) {
      // Error is handled in the hook and dialog will show error
      console.error('Failed to enable notifications:', error);
    }
  };


    const fetchPriorityTransactions = async () => {
    // Check for proper team selection based on view mode
    const currentTeam = filters.selectedTeamTable;
      
    setTransactionData({ rows: [] });
    if (!selectedClient || !currentTeam) {
      setTransactionData({ rows: [] });
      setLoading(false);
      return;
    }
    setLoading(true);
    const payload = {
      page: page + 1,
      size: viewMode === "table" ? rowsPerPage : Number.MAX_SAFE_INTEGER,
      search: search,
      clients: [selectedClient],
      teams: [filters.selectedTeamTable],
      users: [],
      keyword: "",
      eventTypes: [],
      eventStatus: [],
      statusFilter: filters.statusFilter
    };
    try {
      const res = await getPriorityTransactions(payload);
      
      
      // Transform the response to match the expected structure
      const transformedData = {
        ...res?.data,
        filters: {
          count: res?.data?.pagination?.total || 0
        }
      };
      setTransactionCount(res?.data?.counts)
      setTransactionData(transformedData || { rows: [], filters: { count: 0 } });
    } catch {
      setTransactionData({ rows: [], filters: { count: 0 } });
    } finally {
      setLoading(false);
    }
  };  useEffect(() => {
    fetchPriorityTransactions();
    fetchNodeStatus();
  }, [selectedClient, filters.selectedTeamTable, search,viewMode, page, rowsPerPage,filters.statusFilter]);
  
  
  const fetchNodeStatus = async () => {
    try {
      const res = await getNodeStatus(filters.selectedTeamTable);
      if (res.success) {
        fetchKeyStatuses(res.data);

      }
    } catch (error) {
      console.error('Error fetching node status:', error);
    }
  };
  const fetchKeyStatuses = async (reportingStatus: any) => {
  try {
    // const res = await getNodeStatus(teamUid);
    const statusMap: Record<string, string> = {};
    console.log("reportingStatus",reportingStatus)
    reportingStatus.forEach((status: any) => {
      statusMap[status._id] = status.name;
    });
    console.log("statusMap",statusMap)
    setKeyStatusMap(statusMap);
  } catch (error) {
    console.error('Failed to fetch key statuses:', error);
  }
};
  // Reset page when filters change
  useEffect(() => {
    setPage(0);
  }, [selectedClient, filters.selectedTeamTable, search, viewMode]);

  // Dedicated refresh function with toast notification
  const handleRefresh = async () => {
    if (!selectedClient || !selectedTeam) {
      showToast('Please select a client and process to refresh priority transactions', 'warning');
      return;
    }
    
    try {
      await fetchPriorityTransactions();
      showToast('Priority transactions refreshed successfully', 'success');
    } catch (error) {
      showToast('Failed to refresh priority transactions', 'error');
    }
  };

  // Pagination handlers
  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleNotificationDeny = () => {
    // Mark as dismissed so we don't show again
    localStorage.setItem('fcm-permission-dismissed', 'true');
    setShowNotificationDialog(false);
  };

  useEffect(() => {
      const fetchTeams = async () => {
    if (selectedClient) {
      try {
        const res = await getTeamByClient(selectedClient);
     
        const teamsWithAll = [{ uid: 'all', name: 'All' }, ...(res?.data || [])];
        const sortedTeams = [
        teamsWithAll[0],
        ...teamsWithAll.slice(1).sort((a, b) => a.name.localeCompare(b.name))
      ];
      setTeamOptions(sortedTeams);
      setSelectedTeam('all');
      // Ensure filter is set for table mode
      if (!filters.selectedTeamTable || filters.selectedTeamTable === '') {
        handleFilterChange("selectedTeamTable", 'all');
      }
               
        
      } catch {
        setTeamOptions([{ uid: 'all', name: 'All' }]);
        setSelectedTeam('all');
        if(viewMode==="table"){
          handleFilterChange("selectedTeamTable", 'all');
        }
      }
    } else {
      setTeamOptions([]);
      setSelectedTeam('');
    }
  };
      fetchTeams();
    }, [selectedClient, viewMode]);

    useEffect(() => {
      // Client loading is now handled by SelectionContext
      // However, add a fallback check if clients aren't loaded after some time
      const checkClientLoading = setTimeout(async () => {
        if (clientOptions.length === 0 && user) {
          console.log('Dashboard: No clients loaded, attempting fallback refresh...');
          // Trigger a manual refresh of clients if they haven't loaded
          // This can happen on first login when context initialization is delayed
          try {
            await refreshClients();
            console.log('Dashboard: Fallback client refresh completed');
          } catch (error) {
            console.error('Dashboard: Fallback client refresh failed:', error);
          }
        }
      }, 3000); // Wait 3 seconds

      return () => clearTimeout(checkClientLoading);
    }, [clientOptions, user, refreshClients]);
    
    // Remove loadClients function since clients are loaded centrally
    // const loadClients = async () => {
    //   let tagsResp = await getClientsList();
    //   let { success, data } = tagsResp;
    //   if (success) {
    //     setClientOptions(data);
    //     // Auto-select client if there's only one option and no client is currently selected
    //     if (data.length === 1 && !selectedClient) {
    //       setSelectedClient(data[0].uid);
    //     }
    //   }
    // };

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Page Header */}
        <Grid item xs={12}>
          <Box 
            display="flex" 
            alignItems="center" 
            justifyContent="space-between" 
            // mb={1}
            sx={{
              px: { xs: 1, sm: 0 }
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5}>
              {/* <KeyboardDoubleArrowUpIcon sx={{ color: 'primary.main', fontSize: 36 }} /> */}
              <Typography 
                variant="h4" 
                sx={{ 
                  color: 'primary.main',
                  fontWeight: 700,
                  letterSpacing: '0.02em'
                }}
              >
                PRIORITY TRANSACTIONS
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Main Content Card */}
        <Grid item xs={12}>
          <Box
            sx={{
              background: '#fff',
              borderRadius: 1,
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
              border: '1px solid',
              borderColor: 'grey.200',
              overflow: 'hidden'
            }}
          >
            {/* Filters Section */}
            <Box
              sx={{
                p: 2,
                borderBottom: '1px solid',
                borderColor: 'grey.200',
                bgcolor: 'grey.50'
              }}
            >
              <Grid container spacing={2} alignItems="center">
                {clientOptions.length >= 2 && (
                  <Grid item xs={12} sm={6} md={2}>
                    <ClientFilter
                      clientOptions={clientOptions}
                      selectedClient={selectedClient}
                      onChange={setSelectedClient}
                      label="Client"
                    />
                  </Grid>
                )}
                
                <Grid item xs={12} sm={6} md={2.5}>
                  <FormControl
                    size="small"
                    fullWidth
                    sx={{
                      bgcolor: 'white',
                      borderRadius: 1.5,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5
                      }
                    }}
                    disabled={!selectedClient}
                  >
                    <InputLabel id="team-select-label">Processes</InputLabel>
                    <Select
                      labelId="team-select-label"
                      label="Processes"
                      value={filters.selectedTeamTable}
                      onChange={(e) => { handleFilterChange("selectedTeamTable", e.target.value);}}
                    >
                      {teamOptions.map((team: any) => (
                        <MenuItem key={team.uid} value={team.uid}>
                          {team.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={2.5}>
                  <TextField
                    placeholder="Search transactions..."
                    variant="outlined"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    fullWidth
                    size="small"
                    sx={{
                      bgcolor: 'white',
                      borderRadius: 1.5,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon sx={{ color: 'text.secondary' }} />
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>

                {/* Status filter moved here */}
                
              </Grid>
            </Box>

            {/* Header with View Toggle */}
            <Box 
              sx={{ 
                p: 2,
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                borderBottom: '1px solid',
                borderColor: 'grey.200'
              }}
            >
              <Grid item xs={12} sm={6} md="auto">
                  <ToggleButtonGroup
                    color="primary"
                    value={filters.statusFilter || 'all'}
                    exclusive
                    onChange={(_, value) => {
                      if (value) handleFilterChange("statusFilter", value);
                    }}
                    size="small"
                    sx={{
                      bgcolor: 'white',
                      '& .MuiToggleButton-root': {
                        px: 2,
                        textTransform: 'none',
                        borderColor: 'grey.300'
                      },
                      '& .MuiToggleButton-root[value="all"].Mui-selected': {
                        bgcolor: '#d1e1e8',
                        color: 'primary.main',
                        borderColor: 'grey.300',
                        borderWidth: 1,
                        '&:hover': {
                          bgcolor: 'white !important'
                        }
                      },
                      '& .MuiToggleButton-root[value="ALERT"].Mui-selected': {
                        bgcolor: 'accent.dark',
                        color: 'grey.900',
                        borderColor: 'accent.dark',
                        borderWidth: 1,
                        '&:hover': {
                          bgcolor: 'accent.dark'
                        }
                      },
                      '& .MuiToggleButton-root[value="PRIORITY"].Mui-selected': {
                        bgcolor: 'accent.main',
                        color: 'grey.900',
                        borderColor: 'accent.main',
                        borderWidth: 1,
                        '&:hover': {
                          bgcolor: 'accent.main'
                        }
                      }
                    }}
                  >
                    <ToggleButton value="all">
                      All ({transactionCount?.all || 0})
                    </ToggleButton>
                    <ToggleButton
                      value="PRIORITY"
                      sx={{
                        '&:not(.Mui-selected):hover': {
                          bgcolor: 'accent.main'
                        }
                      }}
                    >
                      Notifications ({transactionCount?.priority || 0})
                    </ToggleButton>
                    <ToggleButton
                      value="ALERT"
                      sx={{
                        '&:not(.Mui-selected):hover': {
                          bgcolor: 'error.lighter'
                        }
                      }}
                    >
                      Alerts ({transactionCount?.alert || 0})
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
              
              <Box display="flex" alignItems="center" gap={1}>
                <Tooltip title="Refresh priority transactions">
                  <IconButton
                    onClick={handleRefresh}
                    disabled={isLoadingData}
                    size="small"
                    sx={{
                      bgcolor: 'primary.main',
                      color: 'white',
                      '&:hover': {
                        bgcolor: 'primary.dark'
                      },
                      '&:disabled': {
                        bgcolor: 'grey.300'
                      }
                    }}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>

                <ToggleButtonGroup
                  color="primary"
                  value={viewMode}
                  exclusive
                  onChange={handleViewChange}
                  aria-label="view toggle"
                  size="small"
                >
                  <ToggleButton value="table"><TableRowsIcon /></ToggleButton>
                  <ToggleButton value="card"><ViewKanbanIcon /></ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Box>

            {/* Transaction List */}
            <Box sx={{ p: 2 }}>
              {viewMode === "table" ? (
                <ListViewPriorityTransaction 
                  transactionData={transactionData} 
                  loading={isLoadingData} 
                  fetchPriorityTransactions={fetchPriorityTransactions}
                  statusFilter={filters.statusFilter as 'all' | 'PRIORITY' | 'ALERT'}
                  reportingStatus={keyStatusMap}
                />
              ) : (
                <PriorityTransaction 
                  transactionData={transactionData} 
                  loading={isLoadingData}
                  statusFilter={filters.statusFilter as 'all' | 'PRIORITY' | 'ALERT'}
                  team={filters.selectedTeamTable}
                  reportingStatus={keyStatusMap}
                  
                />
              )}
            </Box>

            {/* Pagination for table view */}
            {viewMode === "table" && (
              <Box
                sx={{
                  borderTop: '1px solid',
                  borderColor: 'grey.200',
                  bgcolor: 'grey.50'
                }}
              >
                <TablePagination
                  component="div"
                  count={transactionData?.filters?.count || 0}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    '& .MuiTablePagination-toolbar': {
                      px: 2,
                      py: 1,
                      minHeight: 52
                    },
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                      fontWeight: 500,
                      color: 'text.secondary',
                      fontSize: '0.875rem'
                    }
                  }}
                />
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Notification Permission Dialog */}
      <NotificationPermissionDialog
        open={showNotificationDialog}
        onClose={() => setShowNotificationDialog(false)}
        onAccept={handleNotificationAccept}
        onDeny={handleNotificationDeny}
        loading={isLoading}
      />
    </Box>
  );
}

export default NewDashboard;
